<template>
    <aside class="map-sidebar">

        <el-button class="sidebar-opener animated"
                   :class="!operateBox?'fadeInRight':'fadeOutRight'"
                   @click="operateBox=true"
        >
            <el-badge :value="allSelected.length" type="primary">
                <i class="nucfont inuc-picture"></i>
            </el-badge>
        </el-button>
        <div class="sidebar-box animated" :class="operateBox?'fadeInRight':'fadeOutRight'">
            <header class="box-title" @click="operateBox=false">
                <h3>组卷面板</h3>
                <i class="nucfont inuc-arrow-circle-right"></i>
            </header>

            <div class="box-info" v-show="!editing">
                <ul class="count">
                    <li>漏检：<span>{{ omitSelected.length }}</span></li>
                    <li>优质：<span>{{ goodSelected.length }}</span></li>
                    <li>合计：<span>{{ allSelected.length }}</span></li>
                </ul>
                <div class="tips" v-if="!allSelected.length">
                    * 请先在图像库中勾选物品
                </div>
                <div class="tips" v-if="unmarkedNum">
                    * 当前存在 {{unmarkedNum}} 个未完善的图像
                </div>
                <el-button @click="toFillForm"
                           size="small" type="success" icon="el-icon-edit" :disabled="!allSelected.length">开始组卷
                </el-button>
                <el-button @click="clearSelect"
                           size="small" icon="el-icon-close" :disabled="!allSelected.length">清空选择
                </el-button>
            </div>

            <div class="box-form" v-show="editing">
                <el-button @click="backToInfo" type="text" icon="el-icon-arrow-left">返回上一级</el-button>

                <el-alert
                    v-if="unmarkedNum"
                    :title="`当前存在 ${unmarkedNum} 个未完善的图像`"
                    description="请先完善该图像，或取消选中该图"
                    type="error"
                    effect="dark"
                    show-icon
                    :closable="false">
                </el-alert>

                <el-form :model="ruleForm"
                         :rules="rules"
                         ref="ruleForm"
                         label-width="100px"
                         size="mini"
                         class="paper-form">

                    <el-form-item :label="$t('paper.name')" prop="title">
                        <el-input v-model="ruleForm.title" :placeholder="$t('tip.paperName')" clearable></el-input>
                    </el-form-item>

                    <el-form-item label="考核形式" prop="pattern" required>
                        <el-radio-group v-model="ruleForm.pattern" prop="pattern">
                            <el-radio-button :label="1">快速判断</el-radio-button>
                            <el-radio-button :label="2">位置标记</el-radio-button>
                            <el-radio-button :label="3">位置标记及类型选择</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="题目名称" prop="topicTitle">
                        <el-input type="textarea"
                                  v-model="ruleForm.topicTitle"
                                  :autosize="{ minRows: 3, maxRows: 5}"
                                  :placeholder="$t('tip.paperName')"
                                  clearable></el-input>
                    </el-form-item>

                    <el-form-item label="每题分数" prop="topicScore">
                        <el-input-number v-model.number="ruleForm.topicScore" controls-position="right"
                                         :min="1" :max="50" :step="1"></el-input-number>
                    </el-form-item>

                    <el-form-item :label="$t('topic.passLine')" prop="passLine">
                        <el-input-number v-model.number="ruleForm.passLine" controls-position="right"
                                         :min="0.1" :max="1" :precision="2" :step="0.1"></el-input-number>
                    </el-form-item>

                    <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge">
                        <el-cascader ref="knowledge"
                                     v-model="ruleForm.knowledge"
                                     :options="knowledgeMenu['Theory']"
                                     :props="cascadeProp"
                                     :placeholder="$t('tip.knowledgePoint')"
                                     :show-all-levels="false"
                                     filterable
                        ></el-cascader>
                    </el-form-item>

                    <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                        <el-select v-model="ruleForm.forLevel" collapse-tags :placeholder="$t('tip.operatorLevel')">
                            <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item :label="$t('c.difficulty')" prop="difficulty">
                        <el-select v-model="ruleForm.difficulty" :placeholder="$t('tip.difficulty')">
                            <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <el-button @click="savePaper"
                           class="btn-save"
                           :loading="submitLoading"
                           :disabled="unmarkedNum"
                           size="small" type="success" icon="nucfont inuc-step-right">生成考卷
                </el-button>
            </div>

        </div>
    </aside>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    props: {
        omitSelected: {
            type: Array,
            default: () => {
                return []
            }
        },
        goodSelected: {
            type: Array,
            default: () => {
                return []
            }
        }
    },

    data() {
        return {
            operateBox: false,
            allSelected: [],
            editing: false,

            ruleForm: {
                title: '',
                topicTitle: '',
                pattern: 1,
                knowledge: [],
                forLevel: '',
                difficulty: '',
                topicScore: 0,
                passLine: 0.6,
            },
            difficultyDict: [],
            rules: {
                title: [
                    {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                    {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                ],
                topicTitle: [
                    {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                    {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                ],
                knowledge: [
                    {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                ],
                forLevel: [
                    {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                ],
                difficulty: [
                    {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                ],
                topicScore: [
                    {type: 'number', required: true, message: '请输入每题的分数', trigger: 'blur'},
                ],
                passLine: [
                    {type: 'number', required: true, message: this.$t('tip.passLine'), trigger: 'blur'},
                    {validator: this.validatePass, trigger: 'blur'}
                ],
            },
            cascadeProp: {
                value: 'id',
                label: 'value',
                children: 'children'
            },
            unmarkedNum: 0,
            submitLoading: false,
        }
    },

    computed: {
        ...mapGetters([
            'forLevelMenu',
            'knowledgeMenu'
        ]),
    },

    watch: {
        omitSelected(v) {
            let omitId = this.omitSelected.map(item => item.imageId)
            let goodId = this.goodSelected.map(item => item.imageId)
            this.allSelected = omitId.concat(goodId)
        },
        goodSelected(v) {
            let omitId = this.omitSelected.map(item => item.imageId)
            let goodId = this.goodSelected.map(item => item.imageId)
            this.allSelected = omitId.concat(goodId)
            this.unmarkedNum = this.goodSelected.filter(item => !item.isCompletion).length
        },
        'ruleForm.pattern': {
            handler(v) {
                let defaultTitle = {
                    1: '请判断是安全还是嫌疑',
                    2: '请判断是安全还是嫌疑，若为嫌疑请标出嫌疑物位置',
                    3: '请判断是安全还是嫌疑，若为嫌疑请标出嫌疑物位置，并选择类型'
                }

                this.ruleForm.topicTitle = defaultTitle[v]
            },
            immediate: true
        }
    },

    mounted() {
        this.$store.dispatch('getForLevelMenu');

        this.$store.dispatch('getKnowledgeMenu', {
            type: 'Theory'
        })

        this.$api.getDifficulty().then(res => {
            this.difficultyDict = res.package;
        });
    },

    methods: {
        toFillForm() {
            this.editing = true
        },

        backToInfo() {
            this.editing = false
        },

        savePaper() {
            // if (this.unmarkedNum) {
            //     return this.$message.error('当前存在未标框的嫌疑图！')
            // }

            let submitData = {
                ...this.ruleForm,
                knowledge: this.ruleForm.knowledge[this.ruleForm.knowledge.length - 1],
                imageIds: this.allSelected
            }

            this.$refs['ruleForm'].validate((valid) => {
                if (!valid) return

                this.submitLoading = true

                this.$api.postOmitPaper(submitData).then(res => {
                    this.$notify({
                        title: '组卷成功！',
                        //message: '您可以返回，或继续编辑',
                        type: 'success',
                    })

                    // 跳到考卷编辑页
                    let paperId = res.package
                    this.$router.push({
                        name: 'editTheoryPaper',
                        params: {paperId,paperType:1},
                        query: {fromMap: true}
                    })

                    this.operateBox = false
                    this.clearSelect()
                    this.submitLoading = false
                }).catch(error => this.submitLoading = false)

            })
        },

        validatePass(rule, value, callback) {
            if (value > 1 || value < 0) {
                return callback(new Error('及格线取值范围是0~1'));
            }
            callback();
        },

        clearSelect() {
            this.$emit('clear-select')
        },

    },
}
</script>

<style lang="scss">

@import '~@/style/const.scss';

$top: 22%;

.map-sidebar {
    position: relative;
    z-index: 8;

    .sidebar-opener {
        position: fixed;
        right: 11px;
        top: $top;
        padding: 10px 20px;
        border-right: none;

        i {
            font-size: 20px;
        }
    }

    .sidebar-box {
        position: fixed;
        right: 7px;
        top: $top;
        background-color: #ccc;
        border: 1px solid #ababac;

        .box-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 36px;
            padding-left: 15px;
            background-color: $blue;
            color: #fff;
            cursor: pointer;

            &:hover {
                opacity: .7;
            }

            i {
                padding: 10px 15px 10px 10px;
            }
        }

        .box-info {
            width: 180px;
            padding: 10px 15px 0 15px;
            background-color: #fff;
            text-align: center;

            .count {
                margin-bottom: 10px;

                li {
                    line-height: 1.8;

                    span {
                        color: $blue;
                        font-weight: 600;
                        font-size: 15px;
                    }
                }
            }

            .tips {
                margin-bottom: 10px;
                font-size: 12px;
                color: $red;
            }

            button {
                margin-left: 0;
                margin-bottom: 15px;
            }
        }

        .box-form {
            //width: 320px;
            padding: 0 25px 20px 20px;
            background-color: #fff;

            .paper-form {
                padding-top: 10px;
            }

            .btn-save {
                display: block;
                margin: 0 auto;
                .nucfont {
                    margin-right: 4px;
                    font-size: 15px;
                    vertical-align: -1px;
                }
            }
        }
    }
}
</style>
